import { DatePipe } from '@angular/common';
import { AfterContentInit, Component, OnInit } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { Process } from 'src/app/domain/MPCE/process';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { Intervention } from 'src/app/domain/planning/intervention';
import { User } from 'src/app/domain/planning/user';
import { Document } from 'src/app/domain/Shared/document';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { SpeedDialFabModel } from 'src/app/models/speed-dial-fab.model';
import { DocumentService } from 'src/app/services/document.service';
import { InterventionService } from 'src/app/services/intervention.services';
import { MPCEService } from 'src/app/services/mpce-service';
import { PictureService } from 'src/app/services/picture.service';
import { UserService } from 'src/app/services/user-service';
import { CoreData } from 'src/app/tools/core-data';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { EDocumentType } from 'src/app/tools/ui/mutilple-file-upload-box/document-type';
import { MultipleFileUploadBoxDialog } from 'src/app/tools/ui/mutilple-file-upload-box/multiple-file-upload-box';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { db } from '../../db/db';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ChangeNavigationService } from 'src/app/tools/change-navigation-service';

@Component({
    selector: 'app-intervention-dashboard',
    templateUrl: './intervention-dashboard.component.html',
    styleUrls: ['./intervention-dashboard.component.scss']
})
export class InterventionDashboardComponent implements OnInit, AfterContentInit {
    EInterventionType = EInterventionType
    model: Intervention = new Intervention();
    public interventionTime;
    canDelete: boolean;
    DocumentList: Document[] = [];
    public FabOptions: SpeedDialFabModel[] =
        [
            {
                Id: 5,
                Text: undefined,
                Icon: 'save'
            },
            // {
            //     Id: 2,
            //     Text: undefined,
            //     Icon: 'list'
            // },
            // {
            //     Id: 0,
            //     Text: undefined,
            //     Icon: 'image'
            // },
            // {
            //     Id: 3,
            //     Text: undefined,
            //     Icon: 'local_drink'
            // },
            {
                Id: 6,
                Text: undefined,
                Icon: 'map'
            },
        ];

    public AllUserList: User[] = [];

    constructor(
        public coreData: CoreData,
        private interventionService: InterventionService,
        private documentService: DocumentService,
        private userService: UserService,
        private mpceService: MPCEService,
        private pictureService: PictureService,
        private route: ActivatedRoute,
        private router: Router,
        private dialog: MatDialog,
        public datepipe: DatePipe,
        private snackBar: MatSnackBar,
        private ChangeNavigationService: ChangeNavigationService) {
        this.ChangeNavigationService.NavigationUsedEmitter.subscribe(x => {
            if (x) {
                // this.save();
            }
        })
    }

    ngOnInit(): void {
    }

    async ngAfterContentInit(): Promise<void> {

        if (!this.route.snapshot.params.interventionCode || !this.route.snapshot.params.type) {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.URL }]);
            return;
        }

        this.pictureService.clearInfo();

        if (Number(this.route.snapshot.params.type) === EInterventionType.LAC ||
            Number(this.route.snapshot.params.type) === EInterventionType.IML) {
            _.remove(this.FabOptions, x => x.Id === 2);
        }

        if (this.coreData.IsOffline) {
            this.AllUserList = await db.getAllUsers();
            this.model = Object.assign(new Intervention(), this.coreData.getOfflineIntervention(this.route.snapshot.params.interventionCode));
            if (this.model.Type === EInterventionType.MPCE) {
                this.model.GroupementPrelevement = (this.coreData.getOfflineProcess(this.model.ProcessCode) as Process)?.GroupementPrelevement;
            }
            if (this.model.Date) {
                this.model.Date = new Date(this.model.Date);
                this.setTime();
            }

            // TODO NEW DB
            const plist = await (await db.getInterventionByCode(this.model.Code)).Documents;
            plist?.forEach(x => {
                this.DocumentList.push(x);
            });

            // this.coreData.getOfflineInterventionPictureList(this.route.snapshot.params.code).forEach(d => {
            //     const doc: Document = new Document();
            //     doc.DocumentType = d.DocumentType;
            //     doc.Name = `${this.datepipe.transform(Date.now(), 'dd-MM-yyyy')}[${this.route.snapshot.params.code}][DT-${d.DocumentType}].jpg`;

            // this.pictureDbService.getPicture(this.pictureDbService.generatePictureKey(this.model.Code, doc.DocumentType)).subscribe(x => {
            //     if (x) {
            //         doc.UIDisabled = false;
            //     } else {
            //         doc.UIDisabled = true;
            //     }
            //     this.DocumentList.push(doc);
            // });
            // });
        } else {
            this.getAvailableUserList();
            this.interventionService.getInterventionDetails(this.route.snapshot.params.interventionCode).subscribe(x => {
                this.model = x;
                if (this.model.Type === EInterventionType.MPCE) {
                    this.mpceService.getGroupement(this.model.ProcessCode).subscribe((y: boolean) => this.model.GroupementPrelevement = y);
                }
                this.setTime();
            });
            this.documentService.getAllDocumentByFilter(this.route.snapshot.params.interventionCode).subscribe(x => {
                this.DocumentList = x.Documents.filter(y => (y.DocumentType >= 1 && y.DocumentType <= 6) || y.DocumentType === 13);
            });
        }
    }

    getInterventionTypeName() {
        return StringConverter.getInterventionTypeName(this.model.Type);
    }

    dateChanged(event: MatDatepickerInputEvent<Date>) {
        const time = this.interventionTime.split(':');
        this.model.Date.setHours(Number(time[0]), Number(time[1]));
    }

    timeSet(event: string) {
        const time = event.split(':');

        this.model.Date = new Date(this.model.Date);
        this.model.Date.setHours(Number(time[0]), Number(time[1]));
        this.setTime();
    }

    setTime() {
        this.interventionTime = `${this.model.Date.getHours()}:${this.model.Date.getMinutes()}`;
    }

    getDocumentTypeName(documentType: EDocumentType) {
        return StringConverter.getDocumentTypeName(documentType);
    }

    async openMultipleUploadDialog() {

        // Removed existing data of StationMap in localStorage and IndexedDb
        // this.coreData.removeFromOfflinePictureList(this.model.Code, EDocumentType.StationMap);
        _.remove(this.DocumentList, d => d.DocumentType === 13);

        await db.deleteStationMap(this.model);
        // TODO NEW DB
        // this.pictureDbService.getPicture(this.pictureDbService.generatePictureKey(this.model.Code, EDocumentType.StationMap)).subscribe((x: any) => {
        //     if (x) {
        //         this.pictureDbService.removePicture(x.id).subscribe(y => {
        //         });
        //     }
        // });

        const dialogRef = this.dialog.open(MultipleFileUploadBoxDialog, {
            data: { code: this.model.Code, type: EDocumentType.StationMap, isForImport: false },
            width: '333px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(async result => {
            if (result) {
                this.DocumentList = [];
                this.DocumentList.push(...await db.getPictureList(this.model));
                // this.coreData.getOfflineInterventionPictureList(this.route.snapshot.params.code).forEach(d => {
                //     const doc: Document = new Document();
                //     doc.DocumentType = d.DocumentType;
                //     doc.Name = `${this.datepipe.transform(Date.now(), 'dd-MM-yyyy')}[${this.route.snapshot.params.code}][DT-${d.DocumentType}].jpg`;
                //     // TODO NEW DB
                //     // this.pictureDbService.getPicture(this.pictureDbService.generatePictureKey(this.model.Code, doc.DocumentType)).subscribe(x => {
                //     //     if (x) {
                //     //         doc.UIDisabled = false;
                //     //     } else {
                //     //         doc.UIDisabled = true;
                //     //     }
                //     //     this.DocumentList.push(doc);
                //     // });
                // });
            }
        });
    }

    dispatch(event: SpeedDialFabModel) {

        switch (event.Id) {
            // case 0:
            //     // alreadyPicked: this.DocumentList.map(x => x.DocumentType)
            //     this.router.navigate([ENavigationRoute.Photo, { interventionCode: this.route.snapshot.params.interventionCode, type: this.model.Type }]);
            //     break;
            // case 2:
            //     this.router.navigate([ENavigationRoute.DescriptionStation, { type: this.route.snapshot.params.type, interventionCode: this.route.snapshot.params.interventionCode }]);
            //     break;
            // case 3:
            //     switch (Number(this.route.snapshot.params.type)) {
            //         case EInterventionType.IBD:
            //             this.router.navigate([ENavigationRoute.IBD, { processCode: this.model.ProcessCode }]);
            //             break;
            //         case EInterventionType.MPCE:
            //             this.router.navigate([ENavigationRoute.MPCE, { interventionCode: this.model.Code, processCode: this.model.ProcessCode, type: this.model.Type }]);
            //             break;
            //         case EInterventionType.IBGN:
            //             this.router.navigate([ENavigationRoute.IBGN, { processCode: this.model.ProcessCode, type: this.model.Type }]);
            //             break;
            //         case EInterventionType.EAU:
            //             this.router.navigate([ENavigationRoute.EAU, { processCode: this.model.ProcessCode, type: this.model.Type }]);
            //             break;
            //         case EInterventionType.LAC:
            //             this.router.navigate([ENavigationRoute.LAC, { processCode: this.model.ProcessCode, type: this.model.Type }]);
            //             break;
            //         case EInterventionType.IBMR:
            //             this.router.navigate([ENavigationRoute.IBMR, { interventionCode: this.model.Code, processCode: this.model.ProcessCode, type: this.model.Type }]);
            //             break;
            //         case EInterventionType.MGCE:
            //             this.router.navigate([ENavigationRoute.MGCE, {  processCode: this.model.ProcessCode, type: this.model.Type }]);
            //             break;
            //         case EInterventionType.IML:
            //             this.router.navigate([ENavigationRoute.IML, { processCode: this.model.ProcessCode, type: this.model.Type }]);
            //             break;
            //     }
            //     break;
            case 5:
                this.save();
                break;
            case 6:
                this.openMultipleUploadDialog();
                break;
        }
    }

    compareUser(u1: User, u2: User): boolean {
        return u1?.Code === u2?.Code;
    }

    getAvailableUserList() {
        this.userService.getAll().subscribe(x => this.AllUserList = x);
    }

    getDocumentFile(document: Document) {
        if (this.coreData.IsOffline) {
            this.router.navigate([ENavigationRoute.DocumentViewer, { code: this.model.Code, type: document.DocumentType }]);
        } else {
            this.documentService.getDocumentByIntervention(this.route.snapshot.params.interventionCode, document.Code).subscribe(x => {
                this.promptFile(x);
            });
        }
    }

    promptFile(x: any) {
        var url = window.URL.createObjectURL(x.body);
        var a = document.createElement('a');

        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(x.headers.get('Content-Disposition'));
        if (matches != null && matches[1]) {
            a.download = matches[1].replace(/['"]/g, '');
        }

        a.href = url;
        // a.download = x.fileName;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();  //afterwards we remove the element again 
    }

    async deleteDocument(document: Document) {
        if (this.coreData.IsOffline) {
            await db.deleteDocument(await db.getInterventionByCode(this.model.Code), document.DocumentType);
            _.remove(this.DocumentList, document);
            // TODO NEW DB
            // this.pictureDbService.getPicture(this.pictureDbService.generatePictureKey(this.model.Code, document.DocumentType)).subscribe((x: any) => {

            //     this.pictureDbService.removePicture(x.id).subscribe(y => {

            //         this.coreData.removeFromOfflinePictureList(this.model.Code, document.DocumentType);
            //         _.remove(this.DocumentList, document);
            //     });
            // });
        } else {
            this.documentService.deleteDocument(this.route.snapshot.params.interventionCode, document.Code).subscribe(x => {
                _.remove(this.DocumentList, document);
            });
        }
    }

    CanDeleteDocument(d: Document) {

        if (this.coreData.IsOffline) {
            if ((d.DocumentType >= 1 && d.DocumentType <= 6) || d.DocumentType === 13) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    }

    save() {
        if (this.coreData.IsOffline) {
            this.coreData.setOfflineIntervention(this.model);
            NotificationManager.handleSuccess(`Intervention mise à jour`, this.snackBar);
        } else {
            this.interventionService.update(this.model).subscribe(x => {
                NotificationManager.handleSuccess(`Intervention mise à jour`, this.snackBar);
            });
        }
    }
}
